import Template from '../utilities/template';

/**
 * @class FormValidator
 */
class FormValidator {
	/**
	 * @param {Object} $form
	 * @param {Object} $errorContainer
	 * @param {FlashMessages} flashMessages
	 */
	constructor($form, $errorContainer, flashMessages) {

		this.$form = $form;
		this.$errorContainer = $errorContainer;
		this.flashMessages = flashMessages;
		this.fields = [];
		this.requiredFieldMessage = 'This field is required';
		this.init();
	}

	/**
	 * @return {FormValidator}
	 */
	init() {
		this.initValidationFields()
			.initErrorTemplate();
		return this;
	}

	/**
	 * @return {FormValidator}
	 */
	initValidationFields() {
		this.$fieldsWithValidator = this.$form.find('[data-validation-pattern]');
		this.$requiredFields = this.$form.find('[required]');
		return this;
	}

	templateString(obj) {
		const data = obj.messages.map(m => `<span class="form-group__error">${m}</span>`);
		return `<div class="form-group__messages">${data}</div>`;
	}

	initErrorTemplate() {
		this.template = new Template(this.templateString.toString());

		return this;
	}

	/**
	 * @return {Boolean}
	 */
	isValid(restrictChange) {

		this.clearPreviousErrors();

		if (!this.requredFieldsAreValid(restrictChange)) {
			return false;
		}

		if (!this.customValidatorFieldsAreValid(restrictChange)) {
			return false;
		}

		return true;
	}

	/**
	 * Clear all errors
	 */
	clearPreviousErrors() {

		this.flashMessages.clear();
		this.$fieldsWithValidator.removeClass('error');
		this.$requiredFields.removeClass('error');
		$('.has-error').removeClass('has-error');
		$('.form-group__messages').remove();
	}

	/**
	 * Ensure required fields are non-empty
	 * @return {Boolean}
	 */
	requredFieldsAreValid(restrictChange) {

		let invalidFields = [];

		//Check fields are non-empty
		this.$requiredFields.each(function () {
			if (!this.value.length) {
				invalidFields.push($(this));
			}
		});

		//Check fields are non-empty
		this.$requiredFields.filter('[type="checkbox"]').each(function () {
			if (!this.checked) {
				invalidFields.push($(this));
			}
		});

		//Include any invalid radios
		invalidFields = invalidFields.concat(this.validateRequiredRadio());

		let formattedFields = [];
		invalidFields.forEach(($field) => formattedFields.push(
			FormValidator.formatInvalidField($field, this.requiredFieldMessage))
		);

		if (!restrictChange) {
			//Revalidate once user makes change
			invalidFields.forEach(($field) => {
				$field.on('change', this.isValid.bind(this));
			});
		}

		if (formattedFields.length) {
			this.displayRequiredFieldErrors(formattedFields);
			return false;
		}


		//Passed
		return true;
	}

	/**
	 * @param {jQuery}$field
	 * @param {string} message
	 * @returns {{field: *, message: *}}
	 */
	static formatInvalidField($field, message) {
		return {
			field: $field,
			message: message
		};
	}

	/**
	 * @returns {Array}
	 */
	validateRequiredRadio() {

		var radioGroups = {};
		var invalidFields = [];

		//Group radios
		this.$requiredFields.filter('[type="radio"]').each((index, element) => {
			let $radio = $(element);

			if (radioGroups[element.name]) {
				radioGroups[element.name] = radioGroups[element.name].add($radio);
				return;
			}

			radioGroups[element.name] = $radio;
		});
		//Check each group has a checked input
		for (var name in radioGroups) {
			if (!radioGroups[name].filter(':checked').length) {
				invalidFields.push(radioGroups[name]);
			}
		}
		return invalidFields;
	}

	/**
	 * @return {Boolean}
	 */
	customValidatorFieldsAreValid(restrictChange) {

		var invalidFields = [];
		var formValidator = this;
		//Check fields are non-empty
		this.$fieldsWithValidator.each(function () {
			let $field, value, regex;

			$field = $(this);
			value = $field.val();

			if (value === false || value === '') {
				return true;
			}
			regex = formValidator.getRegExFromField($field);

			if (!regex.test(value)) {
				invalidFields.push(
					FormValidator.formatInvalidField($field, $field.data('validation-message'))
				);
			}
		});

		if (!restrictChange) {
			//Revalidate once user makes change
			invalidFields.forEach((invalidField) => {
				invalidField.field.on('change', this.isValid.bind(this));
			});
		}


		//Highlight invalid fields fields
		if (invalidFields.length) {
			this.displayFieldErrors(invalidFields);
			return false;
		}
		//Passed
		return true;
	}

	/**
	 * Display errors for required fields
	 * @param  {Array} invalidFields
	 */
	displayRequiredFieldErrors(invalidFields) {

		let customMessage, customMessages = [];
		for (var i in invalidFields) {
			if (invalidFields.hasOwnProperty(i)) {
				this.addErrorToField(invalidFields[i]);

				customMessage = invalidFields[i].field.data('validation-required-message');

				if (customMessage) {
					customMessages.push(customMessage);
				} else {
					this.addErrorToField(invalidFields[i]);
				}
			}
		}

		//Display custom messages if present
		for (i = 0; i < customMessages.length; i++) {
			this.flashMessages.addError('', customMessages[i], this.$errorContainer);
		}
	}

	/**
	 * Display errors for custom validators
	 * @param  {Array} invalidFields
	 */
	displayFieldErrors(invalidFields) {

		for (let i in invalidFields) {
			if (invalidFields.hasOwnProperty(i)) {
				this.addErrorToField(invalidFields[i]);
			}
		}
	}

	/**
	 * @param {Object} invalidField
	 */
	addErrorToField(invalidField) {
		var $parent;

		if (invalidField.field.attr('type') === 'radio') {
			const errorMessage = invalidField.field.attr('data-error-message');
			this.displayErrorOnGroup(invalidField.field.parents('.radio'), errorMessage);
			return;
		}
		if (invalidField.field.attr('type') === 'checkbox') {
			const errorMessage = invalidField.field.attr('data-error-message');
			errorMessage && this.displayErrorOnGroup(invalidField.field.parent(), errorMessage);
			return;
		}

		this.displayErrorOnGroup(invalidField.field.parent(), invalidField.message);
	}

	displayErrorOnGroup($group, message) {
		$group.addClass('has-error')
			.append(this.template.output({
				messages: [message]
			}));
	}

	/**
	 * @param  {Object} $field
	 * @return {RegExp}
	 */
	getRegExFromField($field) {

		var pattern = $field.data('validation-pattern');
		return new RegExp(`${pattern}`, 'i');
	}


	/**
	 * Add a required field after initialisation
	 */
	addRequiredField($field) {

		this.$requiredFields = this.$requiredFields.add($field);
	}

	/**
	 * Remove a required field after initialisation
	 */
	removeRequiredField($field) {

		this.$requiredFields = this.$requiredFields.not($field);
	}
}

export { FormValidator };
export default FormValidator;
